import { createContext, useContext } from 'react'

export type TenantContextProps = {
  /** Current tenant scope. Null for personal or external context */
  tenant: string | null
  /** Property for changing the current tenant. */
  updateTenant: (toTenant: string | null) => void
  /** Property for getting the homepage relative to the current tenant. */
  getTenantHome: (tenant: string | null) => string
  tenantHome: string
}

/** Tenant context. */
const TenantContext = createContext<TenantContextProps>({
  tenant: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  updateTenant: () => {},
  getTenantHome: () => '/',
  tenantHome: '/',
})

export const useAppTenantContext = () => useContext(TenantContext)

export default TenantContext
